import React, { useState } from 'react';
import { useNavigate, Navigate, NavLink } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import DOMPurify from 'dompurify';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function SendOTP() {

    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        email: '',
    });

    const { isAuthenticated } = useAuth();

    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);

        setFormData({
            ...formData,
            [name]: sanitizedValue,
        });
    };

    const handleSendOTP = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const sanitizedEmail = DOMPurify.sanitize(formData.email, { SAFE_FOR_TEMPLATES: true });

            const response = await fetch(`${baseURL}/send-otp`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: sanitizedEmail
                }),
            });

            const result = await response.json();
            console.log('Response body:', result);
            if (response.ok) {
                if (result.status_code === 200) {
                    toast.success(result.message, {
                        onClose: () => navigate('/verifyotp', { state: { email: sanitizedEmail } }),
                    });
                }
                else if (result.status_code === 400) {
                    toast.error(result.message);
                }
            } else {
                toast.error(result.message);
            }

        } catch (error) {
            setErrorMessage('An error occurred during registration.');
        }
        finally {
            setIsLoading(false);
        }

    }

    if (isAuthenticated) {
        return <Navigate to="/" />;
    }


    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                theme="dark"
            />

            <section className='user-form-part'>
                <div className='container'>
                    <div className='row justify-content-center align-items-center'>
                        <div className='col-xl-8 col-md-12 main-user-box'>
                            <div className='row justify-content-center align-items-center row-flex'>
                                <div className='col-md-4 px-0'>
                                    <div className='user-box'>
                                        <img src="assets/images/elements/vidhya_icon.png" className='vidhya_icon' alt="Section-Image" />
                                    </div>
                                </div>
                                <div className='col-md-8 text-center px-0'>
                                    <form onSubmit={handleSendOTP} className="user-form ">
                                        <div className='account my-5'>
                                            <h4 className='user-title'>Create Your Account</h4>
                                            <h5 className='verify_title'>Verify Your Email Address</h5>
                                            <div className="form-group">
                                               {/*  <span class="icon far fa-envelope fa-lg"></span> */}
                                                <input type="email" className="form-control user-email" id="email" name="email" onChange={handleChange} placeholder='Email' required />
                                            </div>
                                            {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}

                                            <button
                                                type="submit"
                                                className='btn-6 view-all-btnn text-capitalize'
                                                disabled={isLoading}
                                            >
                                                {isLoading ? <div class="spinner-border" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div> : 'Verify Email'}
                                            </button>
                                            <h5 className='py-3 already_account_title'>Already have an Account? <NavLink to="/login">Sign In</NavLink></h5>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="user-form-part my-4 d-none">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-8 col-xl-5">
                            <div className="user-form-card">

                                <div className="user-form-group">
                                    <form onSubmit={handleSendOTP} className="user-form ">
                                        <div className="user-form-title">
                                            <h2>Create Your Account</h2>
                                            <p>Verify Your Email Address</p>
                                        </div>
                                        <div className="form-group">
                                            <input type="email" className="form-control user-email" id="email" name="email" onChange={handleChange} placeholder='Enter Email' required />
                                        </div>
                                        {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}

                                        <div className="col-md-12 text-center">
                                            <button
                                                type="submit"
                                                className='btn-6 view-all-btnn mt-3 text-capitalize'
                                                disabled={isLoading}
                                            >
                                                {isLoading ? <div class="spinner-border" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div> : 'Verify Email'}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
